import {Utils} from '@astek/utils';
import {JsonConfigInterface} from './json-config-interface';
import {BorderConfig, BorderConfigJson} from './border-config';
import {RectangleConfig, RectangleConfigJson} from './rectangle-config';
import {HandlesConfig, HandlesConfigJson} from './handles-config';

export type ResultsConfigJson = {
  timeUncertainty: number;
  pressureUncertainty: number;
  timeInteractionSize: number;
  pressureInteractionSize: number;
  line: BorderConfigJson;
  background: RectangleConfigJson;
  handles: HandlesConfigJson;
};

export class ResultsConfig implements JsonConfigInterface<ResultsConfigJson> {

  public readonly line: BorderConfig = new BorderConfig();
  public readonly background: RectangleConfig = new RectangleConfig();
  public readonly handles: HandlesConfig = new HandlesConfig();

  private _timeUncertainty: number = 0;
  private _pressureUncertainty: number = 0;
  private _timeInteractionSize: number = 0;
  private _pressureInteractionSize: number = 0;

  constructor(json?: ResultsConfigJson) {
    if (!Utils.isNullOrUndefined(json)) {
      this.deserializeJson(json);
    }
  }

  public get timeUncertainty(): number {
    return this._timeUncertainty;
  }

  public get pressureUncertainty(): number {
    return this._pressureUncertainty;
  }

  public get timeInteractionSize(): number {
    return this._timeInteractionSize;
  }

  public get pressureInteractionSize(): number {
    return this._pressureInteractionSize;
  }

  public deserializeJson(json: ResultsConfigJson): void {
    this._timeUncertainty = json.timeUncertainty;
    this._pressureUncertainty = json.pressureUncertainty;
    this._timeInteractionSize = json.timeInteractionSize;
    this._pressureInteractionSize = json.pressureInteractionSize;
    this.line.deserializeJson(json.line);
    this.background.deserializeJson(json.background);
    this.handles.deserializeJson(json.handles);
  }
}
